import axios from "axios";
import { useState, useCallback } from "react";
import { toast } from "react-toastify";

const useGetDoctorsByDepartment = () => {
  const [doctors, setDoctors] = useState([]);
  const [isDoctorsLoading, setIsDoctorsLoading] = useState(false);

  const getDoctorsByDepartment = useCallback(async (departmentName) => {
    if (!departmentName) {
      setDoctors([]);
      return;
    }

    setIsDoctorsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const res = await axios.get(
        `/api/v1/phr-app/doctors/department/name/${encodeURIComponent(departmentName)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setDoctors(res.data || []);
    } catch (error) {
      console.error(error, "error");
      // Don't show error toast for 404, 400, or External API errors - just show "No doctors available" message
      if (error.response?.status === 404 || error.response?.status === 400) {
        setDoctors([]);
        return;
      }
      
      const errorMessage = error.response?.data?.message || "";
      // Suppress "External API error" messages
      if (errorMessage.includes("External API error") || errorMessage.includes("Failed to fetch from PHR App API")) {
        setDoctors([]);
        return;
      }
      
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else if (error.response?.status >= 500 && !errorMessage.includes("External API")) {
        // Only show toast for server errors (500+) that are not External API errors
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
      } else if (error.response?.data?.statusCode === 401) {
        localStorage.removeItem("authToken");
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      }
      // For other errors, just set empty array without showing toast
      setDoctors([]);
    } finally {
      setIsDoctorsLoading(false);
    }
  }, []);

  return {
    doctors,
    isDoctorsLoading,
    getDoctorsByDepartment,
  };
};

export default useGetDoctorsByDepartment;
